// Contact Information
export const CONTACT_INFO = {
  PHONE: '+91 77258 98440',
  EMAIL: 'contact@jetdigital.in',
  WHATSAPP_NUMBER: '917725898440',
  WHATSAPP_URL: 'https://wa.me/917725898440',
  WHATSAPP_MESSAGE: 'Hello, I would like to discuss political strategy consultation.'
};

// Office Locations
export const OFFICE_LOCATIONS = [
  // Row 1: Bhopal (left) and Kalapipal (right)
  [
    {
      icon: '🏛️',
      title: 'Bhopal (Head Office)',
      details: [
        '304, Vivek Tower, Bitthan Market',
        'E5 Arera Colony, Commercial Zone',
        'Bhopal - 462016'
      ],
      color: 'bg-jetBlue-100',
      iconColor: 'text-jetBlue-600'
    },
    {
      icon: '🏢',
      title: 'Kalapipal Office',
      details: [
        '544, Ward 13, New Bus Station',
        'Kalapipal, Distt – Shajapur (MP)',
        'Kalapipal - 465337'
      ],
      color: 'bg-purple-100',
      iconColor: 'text-purple-600'
    }
  ],
  // Row 2: Indore (left) and Contact Info (right)
  [
    {
      icon: '🏪',
      title: 'Indore Office',
      details: [
        '23, PU4 Commercial Zone',
        'MR 9, Indore',
        'Indore - 452010'
      ],
      color: 'bg-green-100',
      iconColor: 'text-green-600'
    },
    {
      icon: '📞',
      title: 'Strategy Hotline',
      details: [
        { type: 'phone', text: CONTACT_INFO.PHONE, link: `tel:${CONTACT_INFO.PHONE}` },
        { type: 'email', text: CONTACT_INFO.EMAIL, link: `mailto:${CONTACT_INFO.EMAIL}` }
      ],
      color: 'bg-red-100',
      iconColor: 'text-red-600'
    }
  ]
];

// Political Positions
export const POLITICAL_POSITIONS = [
  { value: '', label: 'Select position' },
  { value: 'minister', label: 'Minister' },
  { value: 'mla', label: 'MLA' },
  { value: 'mp', label: 'MP' },
  { value: 'party-worker', label: 'Party Worker' },
  { value: 'candidate', label: 'Aspiring Candidate' }
];

// Animation Delays
export const ANIMATION_DELAYS = {
  HERO_BADGE: 0.2,
  HERO_TITLE: 0.4,
  HERO_SUBTITLE_1: 0.6,
  HERO_SUBTITLE_2: 0.8,
  HERO_DESCRIPTION_1: 1.0,
  HERO_DESCRIPTION_2: 1.2,
  HERO_CTA: 1.4,
  HERO_STATS_BASE: 1.6,
  HERO_STATS_INCREMENT: 0.2
};

// Hero Counter Values
export const HERO_STATS = {
  campaigns: 88,
  politicians: 5500,
  winRatio: 79,
  states: 15
};

// Video Data for Work Showcase
export const VIDEO_DATA = [
  {
    id: 0,
    title: "Campaign Strategy Video",
    description: "Strategic planning and execution showcase",
    videoSrc: "/assets/file 1.mp4",
    fallbackGradient: "from-blue-500 to-purple-600",
    fallbackIcon: "🎥",
    duration: "2:30"
  },
  {
    id: 1,
    title: "Digital Campaign Content",
    description: "Social media and digital outreach materials",
    videoSrc: "/assets/file 2.mp4",
    fallbackGradient: "from-green-500 to-blue-600",
    fallbackIcon: "📱",
    duration: "3:45"
  },
  {
    id: 2,
    title: "Grassroots Mobilization",
    description: "Community engagement and voter outreach",
    videoSrc: "/assets/file 3.mp4",
    fallbackGradient: "from-purple-500 to-pink-600",
    fallbackIcon: "👥",
    duration: "4:20"
  },
  {
    id: 3,
    title: "Victory Celebration",
    description: "Election success and community celebration",
    videoSrc: "/assets/file 4.mp4",
    fallbackGradient: "from-orange-500 to-red-600",
    fallbackIcon: "🏆",
    duration: "5:15"
  }
];

// Form Validation Messages
export const VALIDATION_MESSAGES = {
  REQUIRED_FIELD: 'This field is required',
  INVALID_PHONE: 'Please enter a valid phone number (e.g., +91 98765 43210)',
  INVALID_EMAIL: 'Please enter a valid email address',
  FORM_SUCCESS: 'Thank you for your interest! Our political strategy team will contact you within 24 hours to schedule your confidential consultation.',
  FORM_ERROR: 'Failed to submit request. Please try again or contact us directly.',
  ONBOARDING_SUCCESS: 'Welcome to Jet Digital! Our team will contact you within 24 hours to begin your political transformation journey.',
  WHATSAPP_VALIDATION: 'Please enter a valid WhatsApp number with country code'
};

// App Configuration
export const APP_CONFIG = {
  AUTO_PLAY_INTERVAL: 5000, // 5 seconds
  COUNTER_ANIMATION_DURATION: 2000, // 2 seconds
  FORM_RESET_DELAY: 3000, // 3 seconds
  INTERSECTION_THRESHOLD: 0.1,
  API_BASE_URL: (process.env.REACT_APP_API_URL || 'https://backend.jetdigital.in').replace(/\/$/, ''),
  FORM_TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3
};
